import React from 'react';
import Skeleton from "UI/Skeleton";
import Sidebar, {Tray} from "Components/Sidebar";

export default function SlideTrackSkeleton() {
    const tray = <Tray>
        <Skeleton className='h-10 w-full rounded m-auto'/>
    </Tray>;

    return <Sidebar tray={tray}>
        <div className='space-y-4 p-4'>
            <Skeleton className='h-32 w-28 rounded'/>
        </div>
    </Sidebar>;
}
